
import { useContext } from 'react';

import { Island, Vertex2 } from '@rta/rta-blueprint-library';

import { addIslandMenuConfig } from './add-island-menu.config';
import { AppContext } from '../../../app/app-context';
import { DisplayMode } from '@r-core';
import { useActionMenuLayer } from '@r-services/render-layers';
import { SvgActionMenu } from '@r-components';

export type AddIslandActionProps = {
	islandId: string;
	offset?: { x?: number; y?: number };
};

export const AddIslandActions = (props: AddIslandActionProps): React.ReactElement => {
	const { islandId, offset = { x: 0, y: 0 }} = props;

	const {
		controller,
		controller: { options, kitchen, navigation }
	} = useContext(AppContext);

	// short circuit
	if (navigation.displayMode !== DisplayMode.Overhead) return <></>;
	if (!options.contextMenu) return <></>;

	const island: Island | null = kitchen.design.islands.findById(islandId);
	const metadataMap = island.panels.children.map((panel) => {
		const cp = panel.getCornerPoints();
		return {
			panel,
			corners: cp.corners,
			// Use panel center for positioning instead of position.origin
			origin: panel.center,
			connections: {
				isTarget: panel.hasTargetConnection,
				isSource: panel.hasSourceConnection
			}
		};
	});

	return <>
		{metadataMap.map((metadata, i) => {
			// base positioning calculations
			const cx = metadata.origin.x;
			const cy = metadata.origin.z;

			const p = new Vertex2({ dataIn: { x: cx, y: cy }});

			if ((metadata.panel.isLeftPanel || metadata.panel.isRightPanel) && (metadata.connections.isSource || metadata.connections.isTarget)) {
				const directionalPadding = new Vertex2({ dataIn: { x: 3 }});
				directionalPadding.rotateAxis(new Vertex2(), metadata.panel.getOriginAngle());
				p.add(directionalPadding);
			}

			// Register each action menu with the render layer system
			// useActionMenuLayer({
			// 	id: `add-island-actions-${islandId}-${i}`,
			// 	x: island.origin.x,
			// 	y: island.origin.z,
			// 	angleCorrection: island.axis.y,
			// 	items: addIslandMenuConfig(island, { ...metadata, controller }),
			// 	priority: i // Use index as priority for consistent ordering
			// });

			return <SvgActionMenu key={i} {...{
				index: i,
				x: p.x,
				y: p.y,
				angleCorrection: -island.axis.y,
				items: addIslandMenuConfig(island, { ...metadata, controller })
			}}/>;
		})}
	</>;

	// return <></>; // Elements are rendered by the render layer system
};
